<template>
  <div class="chart-wrapper">
    <Doughnut :data="chartData" :options="chartOptions" />
     <div class="mention">{{ gradeLetter }}</div>
    <div class="center-text">{{ note.toFixed(2) }}%</div>
    
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    note: {
      type: Number,
      required: true
    }
  },
  computed: {
    chartData() {
      return {
        labels: ['Note', 'Reste'],
        datasets: [
          {
            data: [this.note, 100 - this.note],
            backgroundColor: ['#2196F3', '#e0e0e0'],
            borderWidth: 0
          }
        ]
      }
    },
    chartOptions() {
      return {
        cutout: '80%',
        plugins: {
          tooltip: { enabled: true },
          legend: { display: false }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    },

    gradeLetter() {
      const note = this.note
      if (note >= 90) return 'A'
      if (note >= 85) return 'A-'
      if (note >= 80) return 'B+'
      if (note >= 75) return 'B'
      if (note >= 70) return 'B-'
      if (note >= 65) return 'C+'
      if (note >= 60) return 'C'
      if (note >= 55) return 'C-'
      if (note >= 50) return 'D'
      return 'E'
    }
  },
}
</script>

<style scoped>
.chart-wrapper {
  position: relative;
  margin-bottom: 0%;
  top: 10%;
  left: 20%;
  width: 60%;
  height: 60%;
}
.center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
  color: #bbb;
}

.mention {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
  font-weight: bold;
  color: #163767;
}
</style>
